import classNames from "classnames";
import type { ResolvedAnatomyBinding } from "./componentAnatomy";
import {
    bindingReader,
    Part,
    type AnatomyPartHighlight,
} from "./componentAnatomyParts";
import styles from "./ComponentAnatomyView.module.scss";

/** X-ray plate for Button: focus ring, border, fill, label and count chip. */
export const ButtonSchematic = ({
    bindings,
    highlight,
}: {
    bindings: readonly ResolvedAnatomyBinding[];
    highlight: AnatomyPartHighlight;
}) => {
    const read = bindingReader(bindings);
    const radius = read("border", "border-radius");
    const ringSpread = read("focusRing", "box-shadow (spread)");
    const ringColor = read("focusRing", "box-shadow (color)");

    return (
        <span
            className={classNames(styles.schematic, styles.buttonSchematic)}
            style={{ height: read("background", "height") }}
        >
            {ringSpread !== undefined && ringColor !== undefined && (
                <Part
                    partId="focusRing"
                    highlight={highlight}
                    className={styles.buttonRing}
                    hitInset={`calc(-1 * ${ringSpread})`}
                    style={{
                        borderRadius: radius,
                        boxShadow: `0 0 0 ${ringSpread} ${ringColor}`,
                    }}
                />
            )}
            <Part
                partId="border"
                highlight={highlight}
                className={styles.buttonBorder}
                style={{
                    borderColor: read("border", "border-color"),
                    borderWidth: read("border", "border-width"),
                    borderRadius: radius,
                }}
            />
            <Part
                partId="background"
                highlight={highlight}
                className={styles.buttonBackground}
                style={{
                    backgroundColor: read("background", "background-color"),
                    borderRadius: radius,
                }}
            />
            <span
                className={styles.buttonContent}
                style={{
                    paddingInline: read("background", "padding-inline"),
                    gap: read("background", "gap"),
                }}
            >
                <Part
                    partId="label"
                    highlight={highlight}
                    className={styles.buttonLabel}
                    style={{
                        color: read("label", "color"),
                        fontSize: read("label", "font-size"),
                        fontWeight: read("label", "font-weight"),
                        lineHeight: read("label", "line-height"),
                        letterSpacing: read("label", "letter-spacing"),
                    }}
                >
                    Review
                </Part>
                <Part
                    partId="countChip"
                    highlight={highlight}
                    className={styles.buttonCountChip}
                    style={{
                        backgroundColor: read("countChip", "background-color"),
                        color: read("countChip", "color"),
                        borderRadius: read("countChip", "border-radius"),
                        fontSize: read("countChip", "font-size"),
                    }}
                >
                    4
                </Part>
            </span>
        </span>
    );
};
